import opentelemetry from '@opentelemetry/api';
import pino from 'pino';

// Only allow one param for logging
// So it works the same in development and production (console vs pino)
export type LogMessage = string | object | Error | undefined | unknown;

type Logger = {
  error: (message: LogMessage) => void;
  warn: (message: LogMessage) => void;
  info: (message: LogMessage) => void;
  debug: (message: LogMessage) => void;
};

export type LogLevel = keyof Logger;

// Unified logger interface that works the same in development and production
export const logger: Logger =
  process.env.NODE_ENV === 'development'
    ? console
    : pino({
        formatters: {
          level: (label) => {
            return {
              level: label,
            };
          },
          log(object) {
            const span = opentelemetry.trace.getSpan(
              opentelemetry.context.active(),
            );
            if (span) {
              const { spanId, traceId } = span.spanContext();
              const traceIdEnd = traceId.slice(traceId.length / 2);
              object['dd.trace_id'] = BigInt(`0x${traceIdEnd}`).toString();
              object['dd.span_id'] = BigInt(`0x${spanId}`).toString();
            }
            return object;
          },
        },
      });
